import { put, call, select } from 'redux-saga/effects';
import { getShippingOptions } from '../../actions/deliveryActions';
import { productDetailsAttributeSelector } from '../../selectors';

import { updateProductInfo, thdProductDetailsUpdated } from '../../actions/pricingActions';
import getThdProductDetailsOrNotItsCool from './_getThdProductDetailsOrNotItsCool';
import getLocalOrNationalPricing from './_getLocalOrNationalPricing';
import { getMappedSkus } from './_utils';

function* getThdProductDetailsAndPricing(skuMap, storeNumber) {
  const { config } = yield select();
  const skus = getMappedSkus(skuMap);
  const attributes = yield select(productDetailsAttributeSelector);
  const allowDuplicateSubSkus = attributes?.allowDuplicateSubSkus;
  let thdDetails = {
    products: {
      product: [],
    },
  };
  if (allowDuplicateSubSkus) {
    const thdDetailsObj = yield call(getThdProductDetailsOrNotItsCool, skus, storeNumber, config);
    skuMap.subSkus.forEach((sku) => {
      thdDetailsObj.products.product.forEach((product) => {
        if (Number(sku.sku) === product.defaultSku) {
          thdDetails.products.product.push(product);
        }
      });
      return sku;
    });
  } else {
    thdDetails = yield call(getThdProductDetailsOrNotItsCool, skus, storeNumber, config);
  }

  yield put(
    updateProductInfo({
      newSkus: skuMap,
      thdDetails,
    })
  );
  yield put(thdProductDetailsUpdated());

  const updatedPricing = yield call(getLocalOrNationalPricing);
  yield put(getShippingOptions(skus[0]));

  return updatedPricing;
}

export default getThdProductDetailsAndPricing;
